import React from 'react';
import './Gallery.scss';
import {useState} from 'react';
import {useEffect} from 'react';
import {Link} from 'react-router-dom';
import Spinner from '../spinner/Spinner';
import { Helmet } from 'react-helmet-async';
import {hyphenateText} from '../../helpers';
import { useVisibleProducts } from '../../services/firestore-service';

const Gallery = () => {
    const [productGallery, setProductGallery] = useState([]);
    const { data: products } = useVisibleProducts();

    useEffect(() => {
        if (products && products.length) {
            const gallery = [];

            const shuffleArray = (array) => {
                for (let i = array.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [array[i], array[j]] = [array[j], array[i]];
                }
                return array;
            }

            const buildProductGallery = (products) => {
                    products.forEach(product => {
                        const separated = product.images.reduce((acc, img) => {
                            if (img.url) {
                                acc.push({ id: product.id, url: img.url, name: product.name });
                                // const preloaded = new Image();
                                // preloaded.src = img.url;
                            }
                            return acc;
                        }, []);
                        gallery.push(...separated);
                    });
                }
                buildProductGallery(products);
                const shuffled = shuffleArray(gallery);
                setProductGallery(shuffled);
        }
    }, [products]);

    const renderGalleryItem = (item, i) => {
        return (
            <Link key={i} className="gallery-item" to={`/products/${hyphenateText(item.name)}/${item.id}`} target="_blank">
                <img className="gallery-img fade-in" src={item.url} alt="" key={i} />
                <div className="overlay">
                <span className="material-icons">
                    open_in_new
                </span>
                </div>
            </Link>
        )
    }

    return (
        <section className="main-gallery header-padding">
            <Helmet>
                <title>Gallery | Dragana Jevtovic Ceramics</title>
                <meta name="description" content="Browse plates, bowls, teapots, mugs, servers and place settings made by Dragana Jevtovic in Cape Town, South Africa" />
                <link rel="canonical" href="https://draganajevtovic.com/gallery" />
            </Helmet>
            {productGallery && productGallery.length ? productGallery.map((product, i) => renderGalleryItem(product, i)) : <Spinner />}
        </section>
    )
}

export default Gallery;
